(() => {
  'use strict';

  const MOBILE_QUERY = window.matchMedia('(max-width: 999px)');
  const GALLERY_SELECTOR = 'product-gallery[data-pkm-micro-pearl-gallery]';
  const SLIDE_SELECTOR = '[data-pkm-micro-pearl-video-slide]';

  function keepPosterUntilFirstFrame(media, video) {
    let revealed = false;

    const reveal = () => {
      if (revealed) return;
      revealed = true;
      media.setAttribute('data-pkm-first-frame-ready', '');
    };

    const watchPresentedFrame = () => {
      if (revealed) return;

      if (typeof video.requestVideoFrameCallback === 'function') {
        video.requestVideoFrameCallback(() => reveal());
        return;
      }

      if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
        window.requestAnimationFrame(reveal);
      } else {
        video.addEventListener('timeupdate', reveal, { once: true });
      }
    };

    video.addEventListener('playing', watchPresentedFrame);
    if (!video.paused) watchPresentedFrame();
  }

  function visiblePixels(element) {
    const rect = element.getBoundingClientRect();
    return Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
  }

  function mountGallery(gallery) {
    if (!MOBILE_QUERY.matches || gallery.dataset.pkmMicroPearlMounted === 'true') return;

    const carousel = gallery.querySelector('[data-pkm-micro-pearl-carousel]');
    const slide = gallery.querySelector(SLIDE_SELECTOR);
    const media = slide?.querySelector(':scope > video-media');
    const video = media?.querySelector(':scope > video');
    if (!carousel || !slide || !media || !(video instanceof HTMLVideoElement)) return;

    gallery.dataset.pkmMicroPearlMounted = 'true';
    media.setAttribute('data-pkm-micro-pearl-video-active', '');
    media.setAttribute('autoplay', '');
    media.removeAttribute('show-play-button');
    video.autoplay = true;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;
    video.preload = 'auto';

    keepPosterUntilFirstFrame(media, video);

    let frame = 0;
    const syncPlayback = () => {
      frame = 0;

      if (!MOBILE_QUERY.matches || document.visibilityState !== 'visible' || visiblePixels(slide) < 24) {
        video.pause();
        return;
      }

      /* `media.play()` initializes Impact's loaded/playing lifecycle. The direct native call then
         runs after any carousel-settle pause and avoids its stale `playing`-attribute race on iOS. */
      if (typeof media.play === 'function') media.play();
      video.play().catch(() => {
        if (typeof media.play === 'function') media.play();
      });
    };

    const schedulePlaybackSync = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(syncPlayback);
    };

    carousel.addEventListener('scroll', schedulePlaybackSync, { passive: true });
    carousel.addEventListener('carousel:change', schedulePlaybackSync);
    carousel.addEventListener('carousel:settle', () => window.setTimeout(syncPlayback, 0));
    window.addEventListener('resize', schedulePlaybackSync, { passive: true });
    document.addEventListener('visibilitychange', schedulePlaybackSync);
    MOBILE_QUERY.addEventListener?.('change', schedulePlaybackSync);

    /* Defer one task so Impact's initial carousel lifecycle completes first. */
    window.setTimeout(syncPlayback, 0);
  }

  function mount() {
    if (!MOBILE_QUERY.matches) return;
    document.querySelectorAll(GALLERY_SELECTOR).forEach(mountGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }

  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('product:rerender', mount);
})();
